import React, { useEffect } from "react";
import "../../Styles/PictureProfile.css";

const PictureProfile = ({
  iconChange,
  setChangeProfileModal,
  profileSrc,
  oflineProfileUrl,
}) => {
  return (
    <div className="ChangeProfile">
      <img className="ChangeProfile-image" src="/imgs/Profile/Profileimg.png" />
      <img
        className="ChangeProfile-Profile"
        src={oflineProfileUrl !== undefined ? oflineProfileUrl : profileSrc}
      />
      {iconChange ? (
        <img
          className="ChangeProfile-icon"
          src="imgs/Profile/iconProfile.svg"
          onClick={() => setChangeProfileModal(true)}
        />
      ) : null}
    </div>
  );
};
PictureProfile.defaultProps = {
  iconChange: true,
};
export default PictureProfile;
